import { render, staticRenderFns } from "./ComfirmBox.vue?vue&type=template&id=1d636f15&scoped=true&"
import script from "./ComfirmBox.vue?vue&type=script&lang=js&"
export * from "./ComfirmBox.vue?vue&type=script&lang=js&"
import style0 from "./ComfirmBox.vue?vue&type=style&index=0&id=1d636f15&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d636f15",
  null
  
)

export default component.exports